import { AutogenLayoutEDIResponseDetail } from "./autogen/AutogenLayoutEDIResponseDetail";

export class EDIResponseDetail extends AutogenLayoutEDIResponseDetail {}